import {
	bannerPurpleColor,
	blackColors,
	dangerColor,
	primaryColor,
	whiteColor,
	activeColor,
} from 'assets/jss/material-dashboard-pro-react';

const detailsStyle = (theme) => ({
	informationCard: {
		height: 'calc(100% - 32px)',
	},
	bundleCard: {
		height: 'auto',
		marginTop: '0px !important',
	},
	bannerClass: {
		height: '100%',
		border: `2px solid ${bannerPurpleColor}`,
		margin: '0px !important',
	},
	bannerWrapper: {
		backgroundColor: bannerPurpleColor,
		padding: '15px',
		display: 'flex',
		justifyContent: 'space-between',
	},
	bannerText: {
		color: `${whiteColor} !important`,
		display: 'flex',
		alignItems: 'center',
	},
	rocketImg: {
		height: '60px',
	},
	informationSubheader: {
		marginBottom: 12,
	},
	dataContainer: {
		display: 'flex',
		alignItems: 'flex-start',
		'&::first-of-type': {
			marginTop: 13,
		},
		minHeight: 64,
	},
	dataIcon: {
		display: 'inline-block',
		width: '32px',
		color: blackColors[4],
		fontSize: '24px',
	},
	dataText: {
		display: 'inline-block',
		width: 'calc(100% - 32px)',
	},
	companyName: {
		marginTop: '5px',
	},
	userNotAssigned: {
		position: 'relative',
		top: '-7px',
		height: '40px',
		lineHeight: '40px!important',
		'& button': {
			margin: '-2px 0 2px 5px',
		},
	},
	billingAccount: {
		marginBottom: 4,
	},
	simpleData: {
		marginTop: 11,
		'& p:first-of-type': {
			marginBottom: 6,
		},
	},
	grayIcon: {
		color: blackColors[5],
	},
	bundleSubheader: {
		marginBottom: '16px',
	},
	bundleCardCost: {
		marginRight: 12,
	},
	bundleCardPerMonth: {
		marginLeft: 5,
	},
	bundleCardDetails: {
		marginTop: 14,
		'& > div': {
			'& p': {
				'&:first-of-type': {
					marginBottom: 0,
				},
			},
		},
	},
	billingAccountNumber: {
		marginTop: '6px',
	},
	tariffHeader: {
		marginTop: '15px',
	},
	cardBody: {
		padding: '24px',
		// minHeight: "226px",
		[theme.breakpoints.down('xs')]: {
			paddingLeft: '12px',
			paddingRight: '12px',
		},
		'& a': {
			color: primaryColor[0],
		},
	},
	tarrifCardBody: {
		padding: '24px',
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'column',
		// minHeight: "226px",
		[theme.breakpoints.down('xs')]: {
			paddingLeft: '12px',
			paddingRight: '12px',
		},
		'& a': {
			color: primaryColor[0],
		},
	},
	numberInfo: {
		padding: '30px 0 20px 0',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		'& svg': {
			fontSize: '64px',
			color: blackColors[5],
			marginRight: '8px',
		},
		'& div': {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginLeft: '8px',
			'& p': {
				marginBottom: 0,
			},
		},
	},
	inputWrapper: {
		maxWidth: '288px',
		margin: '0 auto',
		height: '290px',
		[theme.breakpoints.down('xs')]: {
			maxWidth: '220px',
		},
	},
	corpUserMenuItem: {
		marginBottom: 0,
	},
	menuItemWrapper: {
		display: 'flex',
		alignItems: 'center',
		'& > div': {
			marginLeft: '4px',
		},
	},
	noResults: {
		padding: '11px 8px 9px 8px',
		marginBottom: 0,
	},
	hidden: {
		visibility: 'hidden',
	},
	usernameWrapper: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		'& > div': {
			marginLeft: '6px',
			position: 'relative',
			bottom: '1px',
		},
	},
	changingDepartmentInfo: {
		marginTop: '30px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& p': {
			marginBottom: 0,
			textAlign: 'center',
		},
		'& > p': {
			marginTop: '3px',
			marginRight: '10px',
		},
		'& svg': {
			width: '16px',
			height: 'auto',
			color: blackColors[3],
		},
	},
	arrowForwardIcon: {
		marginRight: '2px',
	},
	phoneIcon: {
		marginRight: '4px',
	},
	inlineIcon: {
		height: 24,
		width: 24,
		objectFit: 'cover',
		marginRight: 8,
	},
	mobilePlanPrice: {
		paddingRight: '6px',
	},
	detachButtonWrapper: {
		position: 'absolute',
		right: 24,
		top: 10,
		[theme.breakpoints.down('xs')]: {
			right: 12,
		},
	},
	numberDisconnectedWrapper: {
		position: 'relative',
		bottom: '-1px!important',
		display: 'inline-flex',
		alignItems: 'center',
	},
	numberDisconnectedIcon: {
		'& svg': {
			color: dangerColor[0],
		},
	},
	detachProfileContainer: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		'& > p': {
			margin: 0,
		},
	},
	tooltip: {
		marginLeft: 4,
		position: 'relative',
		bottom: 1,
	},
	simCardDisconnectedTooltip: {
		color: dangerColor[0],
		marginLeft: 4,
	},
	tryAndBuyDescription: {
		marginBottom: 10,
	},
	tryAndBuyUpgradePlan: {
		paddingTop: 20,
	},
	changePlanPending: {
		paddingLeft: '50px!important',
		paddingTop: '20px!important',
		'& > p': {
			maxWidth: 275,
		},
	},
	planCard: {
		display: 'block',
		height: '100%',
	},
	cardGrid: {
		width: '100%',
	},
	bwodLoading: {
		width: '100%',
	},
	tarrifCardWrapper: {
		marginTop: '20px !important',
	},
	activeButtonWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	activeLabel: {
		background: `${activeColor} !important`,
		pointerEvents: 'none !important',
	},
	planExpiryDate: {
		color: `${dangerColor[0]} !important`,
	},
	dateWrapper: {
		display: 'flex',
	},
});

export default detailsStyle;
